import script from "./App.vue?vue&type=script&lang=tsx"
export * from "./App.vue?vue&type=script&lang=tsx"

import "./App.vue?vue&type=style&index=0&id=59c4a9f4&lang=sass"

export default script